
<div
  *ngIf="invoices.length > 0"
>
  <p style="text-align: center">Lista faktur dotyczących przesyłki</p>
  <hr>
  <table  class="uk-table uk-table-hover uk-table-divider">
    <tr>
      <th>Numer</th>
      <th>Data wystawienia</th>
    </tr>
    <tr *ngFor="let invoice of invoices" (click)="openInvoice(invoice.id)">
      <td>
        {{invoice.number}}
      </td>
      <td>
        {{invoice.issue_date}}
      </td>
    </tr>
  </table>

  <hr>
</div>



<div *ngIf="null !== mainIncomeAmount">
  <app-shipment-amount-view-component
    [amount]="mainIncomeAmount"
    [name]="'Pierwotne naliczenie'"
    [currency]="shipmentCurrency"
  >
  </app-shipment-amount-view-component>
</div>

<div *ngIf="null !== afterServiceIncomeAmount">
  <app-shipment-amount-view-component
    [amount]="afterServiceIncomeAmount"
    [name]="'Wtórne naliczenia przesyłki'"
    [currency]="shipmentCurrency"
  >
  </app-shipment-amount-view-component>
</div>

<p *ngIf="null === mainIncomeAmount && null === afterServiceIncomeAmount" style="color: red">
  Brak naliczeń!
</p>


